<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Upcoming Service
          <v-progress-circular
            v-if="isMasterLoading"
            class="ml-5"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title"
                :error-messages="errors.title"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <input
                type="file"
                id="imagepath"
                name="imagepath"
                ref="imagepath"
                accept="image/*"
                :error-messages="errors.imagepath"
                @change="onFileChange"
              />
              <span v-if="errors.imagepath" class="error--text">{{
                errors.imagepath
              }}</span>
              <v-btn
                v-if="image_url"
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.imagepath.value = null), (image_url = null)"
                >Remove</v-btn
              >

              <div id="preview" v-if="image_url" class="mt-5">
                <label for="">Image Preview</label>
                <br />
                <img
                  :src="image_url"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col>
            <v-col sm="12">
              <label for="disclaimer " class="dark-label">Description</label>
              <vue-editor
                ref="disclaimer"
                v-model="form.description"
                class="form-control"
                :error-messages="errors.description"
              />
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'upcoming_services'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Upcoming Service
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import { VueEditor } from "vue2-editor";
import axios from "axios";
export default {
  name: "UpcomingServiceCreatePage",
  components: {
    VueEditor,
  },
  data() {
    return {
      form: {
        title: "",
      },
      isLoading: false,
      isMasterLoading: false,
      image_url: "",
    };
  },
  mounted() {
    // this.getMasters();
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        let formTest = {};
        Object.assign(formTest, this.form);
        let formData = this.jsonToFormData(formTest);
        let attachment = this.$refs.imagepath.files[0];
        formData.append("imagepath", attachment);
        await axios
          .post("/upcoming_services", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(async () => {
            await this.saveUserTimestamp(null, this.form);
            this.isLoading = false;
            this.$router.push("/upcoming-services");
          })
          .catch((error) => {
            this.isLoading = false;
            if (error.response.status != 422) {
              console.error(error);
              this.isUnAuthorised();
            }
          });
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
    jsonToFormData(data) {
      const formData = new FormData();
      this.buildFormData(formData, data);
      return formData;
    },
    buildFormData(formData, data, parentKey) {
      if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File)
      ) {
        Object.keys(data).forEach((key) => {
          this.buildFormData(
            formData,
            data[key],
            parentKey ? `${parentKey}[${key}]` : key
          );
        });
      } else {
        const value = data == null ? "" : data;
        formData.append(parentKey, value);
      }
    },
    onFileChange() {
      this.file = this.$refs.imagepath?.files[0];
      if (this.file) {
        this.image_url = URL.createObjectURL(this.file);
      }
    },
  },
};
</script>
